import React, { useEffect, useState } from 'react';
import { apiService } from '../../services/api';

// Routage de Nexus à chaud (super-administrateur seul) : Claude Opus, GLM ou Qwen chez Scaleway, OpenAI Astra.
// S'applique dès la demande suivante, pour tout le monde (chat, Slack, automatisations). Second réglage : la
// journée du matin et les synthèses de réunion suivent ce modèle, ou restent sur Muse (Mac mini).
const NexusModelSwitch = ({ open }) => {
  const [info, setInfo] = useState(null);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return;
    apiService.get('/nexus/routing').then(setInfo).catch(() => setInfo(null));
  }, [open]);

  if (!info?.can_switch) return null;

  const change = async (values) => {
    setSaving(true);
    setError(null);
    try {
      setInfo(await apiService.put('/nexus/routing', { route: info.route, background: info.background, ...values }));
    } catch (err) {
      setError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const current = info.routes.find((r) => r.id === info.route);
  const selectClass = 'rounded-full border border-white/40 bg-white/15 px-2 py-0.5 text-[11px] font-semibold text-white outline-none hover:bg-white/25 disabled:opacity-60';
  return (
    <div className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-indigo-50">
      <label className="flex items-center gap-1.5" title="Modèle de Nexus pour toute l’équipe (dès la demande suivante)">
        <span>Modèle</span>
        <select value={info.route} disabled={saving} onChange={(e) => change({ route: e.target.value })} className={selectClass}>
          {info.routes.map((r) => (
            <option key={r.id} value={r.id} className="text-slate-900">{r.label} · {r.provider}</option>
          ))}
        </select>
      </label>
      <label className="flex items-center gap-1.5" title="Journée préparée le matin et synthèses des réunions">
        <span>Journée et synthèses</span>
        <select value={info.background || 'nexus'} disabled={saving} onChange={(e) => change({ background: e.target.value })} className={selectClass}>
          <option value="nexus" className="text-slate-900">{info.route === 'astra' ? 'Claude Opus 5.5' : 'Même modèle'}</option>
          <option value="muse" className="text-slate-900">Muse (Mac mini)</option>
        </select>
      </label>
      {current && !current.images && <span className="text-indigo-100/80">sans lecture d’images</span>}
      {error && <span className="text-rose-200">{error}</span>}
    </div>
  );
};

export default NexusModelSwitch;
